export const Scenarios = {
  grocery: "GROCERY",
  school: "SCHOOL",
  park: "PARK",
  market: "MARKET"
};

export const Emotes = {
  happy: "happy",
  neutral: "neutral",
  sad: "sad"
};

export const Characters = {
  popo: "Popo",
  nana: "Nana"
};
